module.exports = __webpack_public_path__ + "img/Maya Dholakia Head Shot.19473810.jpg";